export default "__VITE_ASSET__C$1wScy6__"